

<div class="modal">
  <div class="modal-content">
    <h1 mat-dialog-title>{{selectedVideo.title}}</h1>   
     <p>{{selectedVideo.description}}</p>
    <video class="responsive-video" controls autoplay="true">
      <source src={{selectedVideo.url}} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Close</button>
    </div>
  </div>
</div>
